
import { Box, Divider, IconButton, MenuItem, MenuList, Popover } from '@mui/material';
import React, { memo, useState } from 'react';
import createStyle from './styles';
import { TextCus } from 'components/TextCus';
import { downloadExcelOptionsData } from 'utils';
import { IActionUserOpts } from 'types/actions';

const DownloadExcelOptions = ({ isOpen, onClose, onConfirm }) => {
    const [state, setState] = useState<any>({})

    const styles = createStyle();

    //setting
    const handleAction = (action: string) => async (value?: unknown) => {
        console.log("🚀 ~ handleAction ~ action:", action)
        switch (action) {
            case 'house':
            case 'apartment':
                onConfirm(action)
                handleClose();
                return setState(oldS => ({ ...oldS, isShowSetting: !oldS.isShowSetting }));
            default:
                break;
        }
    };
    const handleClose = () => {
        onClose?.();
    };

    return (
        <>
            <Popover open={!!isOpen} onClose={handleClose} anchorEl={isOpen} sx={{ top: 40 }}>
                <MenuList sx={[styles.container, styles.bgWhite]}>
                    {downloadExcelOptionsData?.map(item => {
                        return (
                            <MenuItem key={`${item.id}`} onClick={handleAction(item.key as IActionUserOpts)}>
                                <Box
                                    sx={[styles.row, styles.btn]}
                                >
                                    <IconButton>{item?.icon}</IconButton>
                                    <TextCus useI18n={item.useI18n}>{item?.title}</TextCus>
                                </Box>
                                {/* Menu change language */}
                            </MenuItem>
                        );
                    })}
                </MenuList>
            </Popover>

        </>
    );
};
export default memo(DownloadExcelOptions);